// Get All Jobs
export const GET_JOBS_REQUEST = 'GET_JOBS_REQUEST';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const GET_JOBS_FAIL = 'GET_JOBS_FAIL';

// updating jobs list
export const UPDATE_ESTIMATE_JOB_LIST = 'UPDATE_ESTIMATE_JOB_LIST';

// ADD, UPDATE JON ITEMS
export const ADD_UPDATE_ITEMS_REQUEST = 'ADD_UPDATE_ITEMS_REQUEST';
export const ADD_UPDATE_ITEMS_SUCCESS = 'ADD_UPDATE_ITEMS_SUCCESS';
export const ADD_UPDATE_ITEMS_FAIL = 'ADD_UPDATE_ITEMS_FAIL';

// ADD, Items
export const ADD_ITEMS_REQUEST = 'ADD_ITEMS_REQUEST';
export const ADD_ITEMS_SUCCESS = 'ADD_ITEMS_SUCCESS';
export const ADD_ITEMS_FAIL = 'ADD_ITEMS_FAIL';

// Search Labours
export const SEARCH_LABORS_REQUEST = 'SEARCH_LABORS_REQUEST';
export const SEARCH_LABORS_SUCCESS = 'SEARCH_LABORS_SUCCESS';
export const SEARCH_LABORS_FAIL = 'SEARCH_LABORS_FAIL';

// Search Part Supply
export const SEARCH_PART_SUPPLY_REQUEST = 'SEARCH_PART_SUPPLY_REQUEST';
export const SEARCH_PART_SUPPLY_SUCCESS = 'SEARCH_PART_SUPPLY_SUCCESS';
export const SEARCH_PART_SUPPLY_FAIL = 'SEARCH_PART_SUPPLY_FAIL';

// deleteing job item
export const DELETE_JOB_ITEM_REQUEST = 'DELETE_JOB_ITEM_REQUEST';
export const DELETE_JOB_ITEM_SUCCESS = 'DELETE_JOB_ITEM_SUCCESS';
export const DELETE_JOB_ITEM_FAIL = 'DELETE_JOB_ITEM_FAIL';

// adding items to inventory
export const ADD_ITEM_TO_INVENTORY_REQUEST = 'ADD_ITEM_TO_INVENTORY_REQUEST';
export const ADD_ITEM_TO_INVENTORY_SUCCESS = 'ADD_ITEM_TO_INVENTORY_SUCCESS';
export const ADD_ITEM_TO_INVENTORY_FAIL = 'ADD_ITEM_TO_INVENTORY_FAIL';

// getting all parts and supplies
export const GET_PARTS_SUPPLIES_REQUEST = 'GET_PARTS_SUPPLIES_REQUEST';
export const GET_PARTS_SUPPLIES_SUCCESS = 'GET_PARTS_SUPPLIES_SUCCESS';
export const GET_PARTS_SUPPLIES_FAIL = 'GET_PARTS_SUPPLIES_FAIL';

// Creating jobs from estimate
export const CREATE_JOBS_ESTIMATE_REQUEST = 'CREATE_JOBS_ESTIMATE_REQUEST';
export const CREATE_JOBS_ESTIMATE_SUCCESS = 'CREATE_JOBS_ESTIMATE_SUCCESS';
export const CREATE_JOBS_ESTIMATE_FAIL = 'CREATE_JOBS_ESTIMATE_FAIL';

// Creating job from estimate
export const CREATE_JOB_ESTIMATE_REQUEST = 'CREATE_JOB_ESTIMATE_REQUEST';
export const CREATE_JOB_ESTIMATE_SUCCESS = 'CREATE_JOB_ESTIMATE_SUCCESS';
export const CREATE_JOB_ESTIMATE_FAIL = 'CREATE_JOB_ESTIMATE_FAIL';

// get canned services
export const GET_CANNED_SERVICES_REQUEST = 'GET_CANNED_SERVICES_REQUEST';
export const GET_CANNED_SERVICES_SUCCESS = 'GET_CANNED_SERVICES_SUCCESS';
export const GET_CANNED_SERVICES_FAIL = 'GET_CANNED_SERVICES_FAIL';

// delete canned services
export const DELETE_CANNED_SERVICE_REQUEST = 'DELETE_CANNED_SERVICE_REQUEST';
export const DELETE_CANNED_SERVICE_SUCCESS = 'DELETE_CANNED_SERVICE_SUCCESS';
export const DELETE_CANNED_SERVICE_FAIL = 'DELETE_CANNED_SERVICE_FAIL';

// updating canned list on delete canned
export const CLEAR_DELETE_CANNED_SERVICE_STATE =
  'CLEAR_DELETE_CANNED_SERVICE_STATE';

// Add Estimate
export const ADD_ESTIMATE_REQUEST = 'ADD_ESTIMATE_REQUEST';
export const ADD_ESTIMATE_SUCCESS = 'ADD_ESTIMATE_SUCCESS';
export const ADD_ESTIMATE_FAIL = 'ADD_ESTIMATE_FAIL';
export const CLEAR_ADD_ESTIMATE_STATE = 'CLEAR_ADD_ESTIMATE_STATE';

// updating estimate state after creating estimate
export const UPDATE_ESTIMATE_STATE = 'UPDATE_ESTIMATE_STATE';

// Authorize Estimate
export const AUTHORIZE_ESTIMATE_REQUEST = 'AUTHORIZE_ESTIMATE_REQUEST';
export const AUTHORIZE_ESTIMATE_SUCCESS = 'AUTHORIZE_ESTIMATE_SUCCESS';
export const AUTHORIZE_ESTIMATE_FAIL = 'AUTHORIZE_ESTIMATE_FAIL';
export const UPDATE_RO_TO_AUTHORIZED = 'UPDATE_RO_TO_AUTHORIZED';

// clearing jobs array

export const CLEAR_JOBS_STATE = 'CLEAR_JOBS_STATE';

// estimated total state management on sidebar
// locally managing
export const ESTIMATED_TOTAL_STATE = 'ESTIMATED_TOTAL_STATE';

// CLEARING NEWLY UPDATED ADDED ITEm,
export const CLEAR_ESTIMATE_STATE_DATA = 'CLEAR_ESTIMATE_STATE_DATA';

export const ADD_NEW_PART_TO_LIST = 'ADD_NEW_PART_TO_LIST';
export const ADD_NEW_SUPPLY_TO_LIST = 'ADD_NEW_SUPPLY_TO_LIST';

// --------Old -------------

// Add Part.

export const ADD_PART_REQUEST = 'ADD_PART_REQUEST';
export const ADD_PART_SUCCESS = 'ADD_PART_SUCCESS';
export const ADD_PART_FAIL = 'ADD_PART_FAIL';

// update estimate

export const UPDATE_ESTIMATE_REQUEST = 'UPDATE_ESTIMATE_REQUEST';
export const UPDATE_ESTIMATE_SUCCESS = 'UPDATE_ESTIMATE_SUCCESS';
export const UPDATE_ESTIMATE_FAIL = 'UPDATE_ESTIMATE_FAIL';

// request for change

export const REQUEST_FOR_CHANGE_REQUEST = 'REQUEST_FOR_CHANGE_REQUEST';
export const REQUEST_FOR_CHANGE_SUCCESS = 'REQUEST_FOR_CHANGE_SUCCESS';
export const REQUEST_FOR_CHANGE_FAIL = 'REQUEST_FOR_CHANGE_FAIL';
export const CLEAR_REQUEST_FOR_CHANGE_STATE = 'CLEAR_REQUEST_FOR_CHANGE_STATE';

// delete estimate

export const DELETE_ESTIMATE_REQUEST = 'DELETE_ESTIMATE_REQUEST';
export const DELETE_ESTIMATE_SUCCESS = 'DELETE_ESTIMATE_SUCCESS';
export const DELETE_ESTIMATE_FAIL = 'DELETE_ESTIMATE_FAIL';
export const CLEAR_DELETE_ESTIMATE_STATES = 'CLEAR_DELETE_ESTIMATE_STATES';

// update part

export const UPDATE_PART_REQUEST = 'UPDATE_PART_REQUEST';
export const UPDATE_PART_SUCCESS = 'UPDATE_PART_SUCCESS';
export const UPDATE_PART_FAIL = 'UPDATE_PART_FAIL';
export const CLEAR_UPDATE_PARTS_STATE = 'CLEAR_UPDATE_PARTS_STATE';

// clear updated estimat state

export const CLEAR_UPDATED_ESTIMATE_STATE = 'CLEAR_UPDATED_ESTIMATE_STATE';

// Add Supply Item

export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST';
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const ADD_ITEM_FAIL = 'ADD_ITEM_FAIL';

// update Supply Item
export const UPDATE_SUPPLY_REQUEST = 'UPDATE_SUPPLY_REQUEST';
export const UPDATE_SUPPLY_SUCCESS = 'UPDATE_SUPPLY_SUCCESS';
export const UPDATE_SUPPLY_FAIL = 'UPDATE_SUPPLY_FAIL';
export const CLEAR_UPDATE_SUPPLY_STATE = 'CLEAR_UPDATE_SUPPLY_STATE';

// delte part/supply
export const DELETE_PART_SUPPLY_REQUEST = 'DELETE_PART_SUPPLY_REQUEST';
export const DELETE_PART_SUPPLY_SUCCESS = 'DELETE_PART_SUPPLY_SUCCESS';
export const DELETE_PART_SUPPLY_FAIL = 'DELETE_PART_SUPPLY_FAIL';

// updating list after deleting item(part/supply) state
export const UPDATE_PART_SUPPLY_LIST = 'UPDATE_PART_SUPPLY_LIST';
// clearing deleted item(part/supply) state
export const CLEAR_DELETED_PART_SUPPLY_STATE =
  'CLEAR_DELETED_PART_SUPPLY_STATE';

// Search Supply By Name
export const SEARCH_SUPPLY_BY_NAME_REQUEST = 'SEARCH_SUPPLY_BY_NAME_REQUEST';
export const SEARCH_SUPPLY_BY_NAME_SUCCESS = 'SEARCH_SUPPLY_BY_NAME_SUCCESS';
export const SEARCH_SUPPLY_BY_NAME_FAIL = 'SEARCH_SUPPLY_BY_NAME_FAIL';

// Search Supply By Vendor

export const SEARCH_SUPPLY_BY_VENDOR_REQUEST =
  'SEARCH_SUPPLY_BY_VENDOR_REQUEST';
export const SEARCH_SUPPLY_BY_VENDOR_SUCCESS =
  'SEARCH_SUPPLY_BY_VENDOR_SUCCESS';
export const SEARCH_SUPPLY_BY_VENDOR_FAIL = 'SEARCH_SUPPLY_BY_VENDOR_FAIL';

// Add Labor
export const ADD_LABOR_REQUEST = 'ADD_LABOR_REQUEST';
export const ADD_LABOR_SUCCESS = 'ADD_LABOR_SUCCESS';
export const ADD_LABOR_FAIL = 'ADD_LABOR_FAIL';

// Search Labor By Category

export const SEARCH_LABOR_REQUEST = 'SEARCH_LABOR_REQUEST';
export const SEARCH_LABOR_SUCCESS = 'SEARCH_LABOR_SUCCESS';
export const SEARCH_LABOR_FAIL = 'SEARCH_LABOR_FAIL';
export const CLEAR_SEARCH_LABOR = 'CLEAR_SEARCH_LABOR';

// Parts Search

export const PARTS_SEARCH_REQUEST = 'PARTS_SEARCH_REQUEST';
export const PARTS_SEARCH_SUCCESS = 'PARTS_SEARCH_SUCCESS';
export const PARTS_SEARCH_FAIL = 'PARTS_SEARCH_FAIL';

// Vendor Search

export const VENDOR_SEARCH_REQUEST = 'VENDOR_SEARCH_REQUEST';
export const VENDOR_SEARCH_SUCCESS = 'VENDOR_SEARCH_SUCCESS';
export const VENDOR_SEARCH_FAIL = 'VENDOR_SEARCH_FAIL';

// VehicleMake Search

export const VEHICLE_MAKE_SEARCH_REQUEST = 'VEHICLE_MAKE_SEARCH_REQUEST';
export const VEHICLE_MAKE_SEARCH_SUCCESS = 'VEHICLE_MAKE_SEARCH_SUCCESS';
export const VEHICLE_MAKE_SEARCH_FAIL = 'VEHICLE_MAKE_SEARCH_FAIL';

// VehicleModel Search

export const VEHICLE_MODEL_SEARCH_REQUEST = 'VEHICLE_MODEL_SEARCH_REQUEST';
export const VEHICLE_MODEL_SEARCH_SUCCESS = 'VEHICLE_MODEL_SEARCH_SUCCESS';
export const VEHICLE_MODEL_SEARCH_FAIL = 'VEHICLE_MODEL_SEARCH_FAIL';

// ModelYear Search

export const MODEL_YEAR_SEARCH_REQUEST = 'MODEL_YEAR_SEARCH_REQUEST';
export const MODEL_YEAR_SEARCH_SUCCESS = 'MODEL_YEAR_SEARCH_SUCCESS';
export const MODEL_YEAR_SEARCH_FAIL = 'MODEL_YEAR_SEARCH_FAIL';

// Estimate Listing

export const GET_ESTIMATE_LISTING_REQUEST = 'GET_ESTIMATE_LISTING_REQUEST';
export const GET_ESTIMATE_LISTING_SUCCESS = 'GET_ESTIMATE_LISTING_SUCCESS';
export const GET_ESTIMATE_LISTING_FAIL = 'GET_ESTIMATE_LISTING_FAIL';

// Get Single Estimate

export const GET_ESTIMATE_BY_ID_REQUEST = 'GET_ESTIMATE_BY_ID_REQUEST';
export const GET_ESTIMATE_BY_ID_SUCCESS = 'GET_ESTIMATE_BY_ID_SUCCESS';
export const GET_ESTIMATE_BY_ID_FAIL = 'GET_ESTIMATE_BY_ID_FAIL';
export const CLEAR_GET_ESTIMATE_BY_ID_STATE = 'CLEAR_GET_ESTIMATE_BY_ID_STATE';

// Get Parts List

export const GET_ALL_PARTS_LIST_REQUEST = 'GET_ALL_PARTS_LIST_REQUEST';
export const GET_ALL_PARTS_LIST_SUCCESS = 'GET_ALL_PARTS_LIST_SUCCESS';
export const GET_ALL_PARTS_LIST_FAIL = 'GET_ALL_PARTS_LIST_FAIL';

// get single part data

export const GET_PART_REQUEST = 'GET_PART_REQUEST';
export const GET_PART_SUCCESS = 'GET_PART_SUCCESS';
export const GET_PART_FAIL = 'GET_PART_FAIL';

// get single supply data

export const GET_SUPPLY_REQUEST = 'GET_SUPPLY_REQUEST';
export const GET_SUPPLY_SUCCESS = 'GET_SUPPLY_SUCCESS';
export const GET_SUPPLY_FAIL = 'GET_SUPPLY_FAIL';

// Export Parts

export const EXPORT_PARTS_REQUEST = 'EXPORT_PARTS_REQUEST';
export const EXPORT_PARTS_SUCCESS = 'EXPORT_PARTS_SUCCESS';
export const EXPORT_PARTS_FAIL = 'EXPORT_PARTS_FAIL';
export const CLEAR_EXPORT_PARTS_STATE = 'CLEAR_EXPORT_PARTS_STATE';

// Import Parts

export const IMPORT_PARTS_SUPPLIES_REQUEST = 'IMPORT_PARTS_SUPPLIES_REQUEST';
export const IMPORT_PARTS_SUPPLIES_SUCCESS = 'IMPORT_PARTS_SUPPLIES_SUCCESS';
export const IMPORT_PARTS_SUPPLIES_FAIL = 'IMPORT_PARTS_SUPPLIES_FAIL';
export const CLEAR_IMPORT_PARTS_STATE = 'CLEAR_IMPORT_PARTS_STATE';

// get silos mototr

export const GET_SILOS_REQUEST = 'GET_SILOS_REQUEST';
export const GET_SILOS_SUCCESS = 'GET_SILOS_SUCCESS';
export const GET_SILOS_FAIL = 'GET_SILOS_FAIL';

// get estimated work times // system/categories

export const GET_SYSTEMS_REQUEST = 'GET_SYSTEMS_REQUEST';
export const GET_SYSTEMS_SUCCESS = 'GET_SYSTEMS_SUCCESS';
export const GET_SYSTEMS_FAIL = 'GET_SYSTEMS_FAIL';

// get motor groups
export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAIL = 'GET_GROUPS_FAIL';

// get motor subgroups(items)
export const GET_SUB_GROUPS_REQUEST = 'GET_SUB_GROUPS_REQUEST';
export const GET_SUB_GROUPS_SUCCESS = 'GET_SUB_GROUPS_SUCCESS';
export const GET_SUB_GROUPS_FAIL = 'GET_SUB_GROUPS_FAIL';

// get motor taxonomies
export const GET_TAXONOMIES_REQUEST = 'GET_TAXONOMIES_REQUEST';
export const GET_TAXONOMIES_SUCCESS = 'GET_TAXONOMIES_SUCCESS';
export const GET_TAXONOMIES_FAIL = 'GET_TAXONOMIES_FAIL';

// get motor workTimes
export const GET_WORK_TIMES_REQUEST = 'GET_WORK_TIMES_REQUEST';
export const GET_WORK_TIMES_SUCCESS = 'GET_WORK_TIMES_SUCCESS';
export const GET_WORK_TIMES_FAIL = 'GET_WORK_TIMES_FAIL';
// get procedures

export const GET_PROCEDURES_REQUEST = 'GET_PROCEDURES_REQUEST';
export const GET_PROCEDURES_SUCCESS = 'GET_PROCEDURES_SUCCESS';
export const GET_PROCEDURES_FAIL = 'GET_PROCEDURES_FAIL';

// get procedure

export const GET_PROCEDURE_REQUEST = 'GET_PROCEDURE_REQUEST';
export const GET_PROCEDURE_SUCCESS = 'GET_PROCEDURE_SUCCESS';
export const GET_PROCEDURE_FAIL = 'GET_PROCEDURE_FAIL';

// get taxonomies for diagrams

export const GET_TAXONOMIES_FOR_DIAGRAMS_REQUEST =
  'GET_TAXONOMIES_FOR_DIAGRAMS_REQUEST';
export const GET_TAXONOMIES_FOR_DIAGRAMS_SUCCESS =
  'GET_TAXONOMIES_FOR_DIAGRAMS_SUCCESS';
export const GET_TAXONOMIES_FOR_DIAGRAMS_FAIL =
  'GET_TAXONOMIES_FOR_DIAGRAMS_FAIL';

// get diagrams

export const GET_DIAGRAMS_REQUEST = 'GET_DIAGRAMS_REQUEST';
export const GET_DIAGRAMS_SUCCESS = 'GET_DIAGRAMS_SUCCESS';
export const GET_DIAGRAMS_FAIL = 'GET_DIAGRAMS_FAIL';

// clear estimated work time state
export const CLEAR_ESTIMATED_WORKTIME_STATE = 'CLEAR_ESTIMATED_WORKTIME_STATE';
// clear motor keys
export const CLEAR_MOTOR_STATE = 'CLEAR_MOTOR_STATE';

// Clear Add Parts State

export const CLEAR_ADD_PARTS_STATE = 'CLEAR_ADD_PARTS_STATE';

// Clear Add Supply State

export const CLEAR_ADD_SUPPLY_STATE = 'CLEAR_ADD_SUPPLY_STATE';

// Clear Get Supply State

export const CLEAR_GET_SUPPLY_STATE = 'CLEAR_GET_SUPPLY_STATE';

// Clear Get Parts State

export const CLEAR_GET_PARTS_STATE = 'CLEAR_GET_PARTS_STATE';

// Clear Add Labor State

export const CLEAR_ADD_LABOR_STATE = 'CLEAR_ADD_LABOR_STATE';

export const CLEAR_LABOUR_PARTS_ERRORS_ESTIMATE_STATE =
  'CLEAR_LABOUR_PARTS_ERRORS_ESTIMATE_STATE';
export const CLEAR_PROCEDURES_ERRORS_ESTIMATE_STATE =
  'CLEAR_PROCEDURES_ERRORS_ESTIMATE_STATE';
export const CLEAR_DIAGRAMS_ERRORS_ESTIMATE_STATE =
  'CLEAR_DIAGRAMS_ERRORS_ESTIMATE_STATE';
